<template>
  <div>
    <v-progress-linear indeterminate color="purple" class="mb-2" v-if="cargando" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-table-presupuestos-consolidados"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="items"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :pinnedBottomRowData="pinnedBottomRowData"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true"
      @first-data-rendered="onFirstDataRendered"
      @grid-ready="onGridReady">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import ListadoAgGridMixin from '../mixins/listado-ag-grid-mixin';
import { formatearValorAMoneda } from '../utils';

export default {
  name: 'ListadoPresupuestosConsolidados',
  mixins: [ListadoAgGridMixin],
  computed: {
    pinnedBottomRowData() {
      return [this.obtenerTotales()];
    },
  },
  data() {
    return {
      columnDefs: [
        {
          headerName: 'CÓDIGO',
          field: 'codigo',
          filter: true,
          checkboxSelection: true,
          minWidth: 140,
          maxWidth: 140,
        },
        {
          headerName: 'CUENTA',
          field: 'nombre',
          filter: true,
          minWidth: 250,
        },
        {
          headerName: 'ENERO',
          field: 'enero',
          filter: false,
          minWidth: 110,
          maxWidth: 110,
          type: 'numericColumn',
          valueFormatter: (params) => {
            return formatearValorAMoneda(params.value);
          },
        },
        {
          headerName: 'FEBRERO',
          field: 'febrero',
          filter: false,
          minWidth: 110,
          maxWidth: 110,
          type: 'numericColumn',
          valueFormatter: (params) => {
            return formatearValorAMoneda(params.value);
          },
        },
        {
          headerName: 'MARZO',
          field: 'marzo',
          filter: false,
          minWidth: 110,
          maxWidth: 110,
          type: 'numericColumn',
          valueFormatter: (params) => {
            return formatearValorAMoneda(params.value);
          },
        },
        {
          headerName: 'ABRIL',
          field: 'abril',
          filter: false,
          minWidth: 110,
          maxWidth: 110,
          type: 'numericColumn',
          valueFormatter: (params) => {
            return formatearValorAMoneda(params.value);
          },
        },
        {
          headerName: 'MAYO',
          field: 'mayo',
          filter: false,
          minWidth: 110,
          maxWidth: 110,
          type: 'numericColumn',
          valueFormatter: (params) => {
            return formatearValorAMoneda(params.value);
          },
        },
        {
          headerName: 'JUNIO',
          field: 'junio',
          filter: false,
          minWidth: 110,
          maxWidth: 110,
          type: 'numericColumn',
          valueFormatter: (params) => {
            return formatearValorAMoneda(params.value);
          },
        },
        {
          headerName: 'JULIO',
          field: 'julio',
          filter: false,
          minWidth: 110,
          maxWidth: 110,
          type: 'numericColumn',
          valueFormatter: (params) => {
            return formatearValorAMoneda(params.value);
          },
        },
        {
          headerName: 'AGOSTO',
          field: 'agosto',
          filter: false,
          minWidth: 110,
          maxWidth: 110,
          type: 'numericColumn',
          valueFormatter: (params) => {
            return formatearValorAMoneda(params.value);
          },
        },
        {
          headerName: 'SEPTIEMBRE',
          field: 'septiembre',
          filter: false,
          minWidth: 110,
          maxWidth: 110,
          type: 'numericColumn',
          valueFormatter: (params) => {
            return formatearValorAMoneda(params.value);
          },
        },
        {
          headerName: 'OCTUBRE',
          field: 'octubre',
          filter: false,
          minWidth: 110,
          maxWidth: 110,
          type: 'numericColumn',
          valueFormatter: (params) => {
            return formatearValorAMoneda(params.value);
          },
        },
        {
          headerName: 'NOVIEMBRE',
          field: 'noviembre',
          filter: false,
          minWidth: 110,
          maxWidth: 110,
          type: 'numericColumn',
          valueFormatter: (params) => {
            return formatearValorAMoneda(params.value);
          },
        },
        {
          headerName: 'DICIEMBRE',
          field: 'diciembre',
          filter: false,
          minWidth: 110,
          maxWidth: 110,
          type: 'numericColumn',
          valueFormatter: (params) => {
            return formatearValorAMoneda(params.value);
          },
        },
        {
          headerName: 'TOTAL',
          field: 'total',
          filter: false,
          minWidth: 110,
          maxWidth: 110,
          type: 'numericColumn',
          valueFormatter: function (params) {
            return formatearValorAMoneda(params.value);
          },
        },
      ],
    };
  },
  methods: {
    obtenerTotales() {
      const totales = {
        enero: 0,
        febrero: 0,
        marzo: 0,
        abril: 0,
        mayo: 0,
        junio: 0,
        julio: 0,
        agosto: 0,
        septiembre: 0,
        octubre: 0,
        noviembre: 0,
        diciembre: 0,
        total: 0,
      };

      this.items.forEach((item) => {
        totales.enero += parseFloat(item.enero);
        totales.febrero += parseFloat(item.febrero);
        totales.marzo += parseFloat(item.marzo);
        totales.abril += parseFloat(item.abril);
        totales.mayo += parseFloat(item.mayo);
        totales.junio += parseFloat(item.junio);
        totales.julio += parseFloat(item.julio);
        totales.agosto += parseFloat(item.agosto);
        totales.septiembre += parseFloat(item.septiembre);
        totales.octubre += parseFloat(item.octubre);
        totales.noviembre += parseFloat(item.noviembre);
        totales.diciembre += parseFloat(item.diciembre);
        totales.total += parseFloat(item.total);
      });

      return { codigo: 'TOTALES', ...totales };
    },
  },
};
</script>

<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';
@import './../css/styles.css';

.ag-grid-table-presupuestos-consolidados {
  height: calc(var(--vh, 1vh) * 100 - 19.5rem);
}

.ag-header-group-cell-label {
  justify-content: center !important;
}
</style>